<div class="container">
  <div class="row">
    <div class="col-12 title">
      <img
        *ngIf="logoMobile"
        loading="lazy"
        [src]=logoMobile
        class="image"
        alt="logo"
        width="70"
        height="70"/>
      <h3>{{ 'COMMON.BAGS_MASTER.TITLE' | translate : { shopName: shopName } }}</h3>
      <span class="close" (click)="close()">
        <svg-icon key="icon-close" class="image" aria-label="close"></svg-icon>
      </span>
    </div>
  </div>

  <app-glovo-bags-master [customer]="customer"></app-glovo-bags-master>

</div>
